import { PersonRequest } from "@plinknz/tah-website-elements";
import { personalDetailsConfig } from "./config-generics/personal-details";
import { signatureConfig } from "./config-generics/signature";
import { PageConfig } from "../../components/content-blocks/forms/customer-form-types";
import { UserData } from "../reducers/user";
import { overviewConfig } from "./config-generics/overview";
import { groupConfig } from "./config-generics/group";
import { bankConfig } from "./config-generics/bank-details";

export const createSurveyConfig = (member: PersonRequest, user?: UserData) => {
    const personalConfig = personalDetailsConfig({
        member,
        children: user.onSameEmail,
    });

    const overviewDetailsConfig = overviewConfig({
        heading: "Tahua Ahurea | Cultural Activities Grant",
        content: [
            {
                heading: "Overview",
                lines: [
                    `Supports participation in kaupapa Māori such as kapa haka,
                    Ngā Manu Kōrero, wānanga, or other cultural events. It is
                    for registered whānau of Ngāti Kuia who are actively
                    involved in activities that strengthen cultural identity
                    and connection.`,
                ],
            },
            {
                heading: "Eligibility",
                lines: [
                    "To apply for this grant, you must:",
                    [
                        "Be a registered member of Ngāti Kuia",
                        "Provide proof of bank account (deposit form or electronic statement).",
                        "Provide proof of the kaupapa Māori activity.",
                    ],
                ],
            },
            {
                heading: "Key Dates & Deadlines",
                lines: [
                    [
                        "Deadline: six weeks before the event.",
                        "Payment: before the event.",
                    ],
                ],
            },
            {
                heading: "Funding Available",
                lines: [
                    "The minimum for individuals is $150, but this varies depending on the kaupapa. The maximum for a whānau group is $500.",
                ],
            },
            {
                heading: "Documents You'll Need",
                lines: [
                    [
                        "Bank account details (deposit form or electronic statement).",
                        "Proof of the kaupapa Māori activity.",
                    ],
                ],
            },
        ],
    });

    const otherConfig: PageConfig[] = [
        {
            name: "circumstances",
            title: "Event - Kaupapa",
            questions: [
                {
                    name: "event",
                    title: "Provide details of the kaupapa or cultural event.",
                    placeHolder: "Kaupapa",
                    type: "comment",
                    isRequired: true,
                },
                {
                    name: "benefit",
                    title: "How will this be of benefit to Ngāti Kuia?",
                    placeHolder: "Ngā hua",
                    type: "comment",
                    isRequired: true,
                },
                {
                    type: "file",
                    name: "attachments",
                    title:
                        "Please upload any supporting documentation relevant to your application (e.g. proof of event)",
                    storeDataAsText: false,
                    allowMultiple: true,
                    maxSize: 10485760,
                    waitForUpload: true,
                    startWithNewLine: true,
                    isRequired: true,
                },
            ],
        },
    ];

    const pages: PageConfig[] = [
        ...overviewDetailsConfig,
        ...personalConfig,
        ...bankConfig,
        ...groupConfig,
        ...otherConfig,
        ...signatureConfig,
    ];

    return { pages };
};
